























































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import transactionServices from '@/services/transition-services';
import formatNumber from '@/shared/filters/format-number';
import commonService from '@/services/common-services';
import { APP_CONFIG } from '@/config/app-config';
import { DATA } from '@/config/data';
import { Product } from '@/models/product';
@Component
export default class ListTransition extends Vue {
    @Prop({ default: {} })
    private listItem: any;
    private editModel = false;
    private currentItem: any = {};
    private expandedRows: { [key: string]: boolean } = {};

    get feeGuarantees() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].feeGuarantee;
    }

    get feeChecks() {
        return DATA.FEE_CHECK;
    }

    // Sử dụng filter global nếu đã đăng ký, nếu không thì dùng local
    // @ts-ignore
    private formatNumber = formatNumber;

    private togglePackagesDetail(itemId: string | number) {
        const key = String(itemId);
        this.$set(this.expandedRows, key, !this.isRowExpanded(key));
    }

    private transformNumb(value: number, format: string) {
        if (!(value > 0)) {
            return '0';
        }
        return formatNumber(value, format);
    }

    private isRowExpanded(itemId: string | number): boolean {
        return !!this.expandedRows[String(itemId)];
    }

    private async created() {
        if (!this.feeGuarantees) {
            await this.getFeeGuarantee();
        }
    }

    private async getFeeGuarantee() {
        const result = await commonService.getFeeGuarantee();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_FEEGUARANTEE', result.data.data);
        }
    }

    private complain(item: any) {
        if (item && item.ID) {
            this.$router.push({ name: 'ecommerce-complain', params: { orderId: item.ID.toString(), orderType: '4', transactionCode: item.TransactionCode } });
        }
    }

    private editItem(item: any) {
        if (item && item.ID) {
            this.currentItem = item;
            this.editModel = true;
        }
    }

    private async saveItem() {
        const dataRequest: any =  {
            ProductName: this.currentItem.ProductName,
            ProductAmount: this.currentItem.ProductAmount,
            ProductNumber: this.currentItem.ProductNumber,
            IsFragileGoods: this.currentItem.IsFragileGoods,
            IsFoam: this.currentItem.IsFoam,
            ID: this.currentItem.ID,
        };
        if(this.currentItem.GuaranteeType > 0) {
            dataRequest.IsGuarantee = 1;
        }
        if(this.currentItem.CheckFeeType > 0) {
            dataRequest.IsCheck = 1;
        }
        const result = await transactionServices.updateDetail(this.currentItem.ID || 0, dataRequest);
        if (result && result.status === 200 && result.data.status === 200) {
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Thông báo!',
                text: 'Cập nhật thành công',
            });
            this.editModel = false;
        } else {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'Không thể cập nhật mã vận đơn',
            });
        }
    }
}
